// Register the main Slimmy service worker for offline cache.
// The Firebase messaging SW (/firebase-messaging-sw.js) is registered
// separately from src/lib/firebase.js and lives at its own scope.

export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  // Only register in production to avoid dev-server cache issues
  if (process.env.NODE_ENV !== 'production') return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((reg) => {
        // Check for updates on each load
        reg.update().catch(() => {});

        // Activate a new SW as soon as it's ready
        if (reg.waiting) {
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              installing.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch((err) => {
        console.warn('[SW] Registration failed:', err.message);
      });
  });
}

// Call this on logout to drop cached user-scoped API responses
export function clearApiCache() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((reg) => {
      reg.active?.postMessage({ type: 'CLEAR_API_CACHE' });
    })
    .catch(() => {});
}
